import type { TourDefinition } from '../types';

export const globalTour: TourDefinition = {
  id: 'global',
  title: 'Bem-vindo ao Mengage CRM',
  steps: [
    {
      popover: {
        title: 'Bem-vindo ao Mengage CRM! 👋',
        description:
          'Vamos fazer um tour rápido para você conhecer as principais funcionalidades da plataforma.',
      },
    },
    {
      element: '[data-tour="global-sidebar"]',
      popover: {
        title: 'Menu de Navegação',
        description:
          'Use o menu lateral para acessar todas as áreas do CRM. Ele se expande ao passar o mouse.',
        side: 'right',
        align: 'start',
      },
    },
    {
      element: '[data-tour="global-search"]',
      popover: {
        title: 'Busca Rápida',
        description:
          'Encontre leads, empresas e negócios rapidamente usando a busca global.',
        side: 'bottom',
        align: 'center',
      },
    },
    {
      element: '[data-tour="global-quick-add"]',
      popover: {
        title: 'Criação Rápida',
        description:
          'Crie leads, empresas, negócios e atividades com um clique.',
        side: 'bottom',
        align: 'center',
      },
    },
    {
      element: '[data-tour="global-notifications"]',
      popover: {
        title: 'Notificações',
        description:
          'Acompanhe alertas e atualizações importantes em tempo real.',
        side: 'bottom',
        align: 'center',
      },
    },
    {
      element: '[data-tour="global-org-switcher"]',
      popover: {
        title: 'Sua Conta',
        description:
          'Alterne entre organizações, acesse configurações e o menu de ajuda.',
        side: 'bottom',
        align: 'end',
      },
    },
  ],
};
